import { render, staticRenderFns } from "./bindphone.vue?vue&type=template&id=2ccfe5ff&"
import script from "./bindphone.vue?vue&type=script&lang=ts&"
export * from "./bindphone.vue?vue&type=script&lang=ts&"
import style0 from "./bindphone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports